import React, { Component, ReactNode } from 'react'
import { connector, AlertStateProps } from './Alert.state'
import Notify from '../Notify'

export interface AlertProps {
  children?: ReactNode
}

type AlertCombinedProps = AlertProps & AlertStateProps

class Alert extends Component<AlertCombinedProps> {
  render () {
    return (
      <Notify
        visible={this.props.visible}
        type={this.props.type}
        message={this.props.message} />
    )
  }
}

export default connector(Alert)
